﻿/* 
Object:         Enum Module 
Used in:        Every Module 
*/

window.ModuleEnum = {};

Object.defineProperties(window.ModuleEnum, {
    Unknown: { value: 0, writable: false },
    Administration: { value: 1, writable: false },
    Information: { value: 2, writable: false },
    UserConfiguration: { value: 3, writable: false },
    Location: { value: 4, writable: false },
    Figures: { value: 10, writable: false },
    NodeManage: { value: 11, writable: false },
    Addressbook: { value: 16, writable: false },
    Notes: { value: 17, writable: false },
    ManageNodeNoAdding: { value: 21, writable: false },
    Help: { value: 30, writable: false },
    UserHistory: { value: 34, writable: false },
    NodeConfiguration: { value: 74, writable: false },
    GroupConfiguration: { value: 75, writable: false },
    FunctionConfiguration: { value: 77, writable: false },
    Occupancy: { value: 79, writable: false },
    PreComMessageLog: { value: 80, writable: false },
    PagerLog: { value: 81, writable: false },
    AlarmLog: { value: 82, writable: false },
    ResponseLog: { value: 83, writable: false },
    UserScheduler: { value: 84, writable: false },
    LCD: { value: 85, writable: false },
    MaintainenceMessage: { value: 86, writable: false },
    GroupChange: { value: 87, writable: false },
    Report: { value: 88, writable: false },
    NodeWebServiceCredentials: { value: 89, writable: false },
    AvailableUsers: { value: 90, writable: false },
    WebService: { value: 91, writable: false },
    OccupancyProposal: { value: 92, writable: false },
    OccupancyRegion: { value: 93, writable: false },
    Import: { value: 94, writable: false },
    Capcodes: { value: 95, writable: false },
    RegioReport: { value: 96, writable: false },
    Documents: { value: 97, writable: false },
    UserPiketScheduler: { value: 98, writable: false },
    MsgUserAvailableLog: { value: 99, writable: false },
    OccupancyRegionMap: { value: 100, writable: false },
    NodeCapcode: { value: 101, writable: false },
    OccupancyStateLog: { value: 102, writable: false },
    UserTabGeneral: { value: 103, writable: false },
    UserTabMove: { value: 105, writable: false },
    UserTabRoles: { value: 106, writable: false },
    UserTabFuntions: { value: 107, writable: false },
    UserTabAgenda: { value: 108, writable: false },
    UserTabCapcode: { value: 109, writable: false },
    UserTabPager: { value: 110, writable: false },
    UserTabGroupChange: { value: 111, writable: false },
    UserTabGroupSwitch: { value: 112, writable: false },
    UserProfile: { value: 113, writable: false },
    NodeMove: { value: 114, writable: false },
    EditBigBrotherRightsOnNode: { value: 115, writable: false },
    NodeSearch: { value: 116, writable: false },
    GroupTabGeneral: { value: 117, writable: false },
    GroupTabUser: { value: 118, writable: false },
    GroupTabFunctions: { value: 119, writable: false },
    GroupTabVehicle: { value: 120, writable: false },
    GroupTabMinOccupancy: { value: 121, writable: false },
    GroupTabCapCode: { value: 122, writable: false },
    GroupTabAgenda: { value: 123, writable: false },
    GroupTabPattern: { value: 124, writable: false },
    GroupTabCrew: { value: 125, writable: false },
    PreComMessageResponse: { value: 126, writable: false },
    PreComMessageGroup: { value: 127, writable: false },
    PreComMessageConfiguration: { value: 128, writable: false },
    PreComMessageScenario: { value: 129, writable: false },
    WebApiResponseLog: { value: 130, writable: false },
    ReportPerUser: { value: 131, writable: false },
    ReportPerMessage: { value: 132, writable: false },
    WebserviceCredentials: { value: 133, writable: false },
    ApplicationLogBook: { value: 134, writable: false },
    UserPiketScheduler: { value: 135, writable: false },
    IncidentTest: { value: 136, writable: false }
});

Object.freeze(window.ModuleEnum);